import Slug from './Slug';
export default Slug;
